export class HeaderDto {
    stepCart: boolean;
    deliveryAndPayment: boolean;
    address: boolean;
    showHeaderGuide: boolean;
}
